module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['order-step-1', {
      'order-step-1--private': _vm.mode === 'private'
    }, ("order-step-1--active-option-" + _vm.subscriptionTypeIndex)],
    style: (_vm.cssVars)
  }, [_c('div', {
    staticClass: "order-step-1__col-container"
  }, _vm._l((_vm.items), function(i, index) {
    return _c('div', {
      key: i.id,
      class: ['order-step-1__col', ("order-step-1__col-" + (index + 1))],
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.updateActiveSubscriptionType(i.id)
        }
      }
    }, [_c('div', {
      staticClass: "order-step-1__image-container"
    }, [_c('img', {
      staticClass: "order-step-1__image",
      attrs: {
        "src": _vm.imgSrc(i),
        "alt": i.name
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "order-step-1__text-container text-container"
    }, [_c('h3', [_vm._v(_vm._s(i.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(i.description))])]), _vm._v(" "), _c('div', {
      staticClass: "order-step-1__radio-container radio"
    }, [_c('label', {
      staticClass: "order-step-1__label"
    }, [_c('input', {
      attrs: {
        "name": "subscription-type",
        "type": "radio"
      },
      domProps: {
        "value": i.id,
        "checked": i.id === _vm.activeSubscriptionType
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "order-step-1__radio custom-radio"
    }), _vm._v(" "), _c('span', {
      staticClass: "sr-only"
    }, [_vm._v(_vm._s(i.name))])])])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4583eab6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./static/js/Order/components/SubscriptionTypes.vue
// module id = 731
// module chunks = 0